module.exports = __webpack_public_path__ + "img/02.3df7af88.png";